import React from 'react';

import {
  getGradientBackground,
  resolveSupporterStyle,
} from '../supporterStyles';

const SupporterName = ({
  name,
  supColor,
  className = '',
}) => {
  const supporterStyle =
    resolveSupporterStyle(supColor);

  if (supporterStyle.type === 'solid') {
    return (
      <span
        className={[
          'supporter-name',
          className,
        ]
          .filter(Boolean)
          .join(' ')}
        style={{
          color: supporterStyle.value,
        }}
      >
        {name}
      </span>
    );
  }

  if (supporterStyle.type === 'gradient') {
    return (
      <span
        className={[
          'supporter-name',
          'supporter-name--gradient',
          supporterStyle.animated
            ? 'supporter-name--animated'
            : '',
          className,
        ]
          .filter(Boolean)
          .join(' ')}
        style={{
          backgroundImage:
            getGradientBackground(
              supporterStyle
            ),
        }}
      >
        {name}
      </span>
    );
  }

  return (
    <span
      className={[
        'supporter-name',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {name}
    </span>
  );
};

export default SupporterName;